import seller from "../../assets/seller-image.svg";
import naira from "../../assets/naira.png";
import CartContentArea from "../../layouts/cart/CartContentArea";
import AddressInput from "../form-input/address-input/AddressInput";

const DeliveryDetail = ({ details, setDeliveryOption }) => {
  const handleDeliveryOption = (e) => {
    if (e.target.checked) setDeliveryOption(e.target.value);
  };
  return (
    <div className="pb-10">
      {details.length > 0 && (
        <>
          <div className="mt-8 font-bold text-lg md:text-xl">
            Delivery Details
          </div>

          <CartContentArea>
            <div className="flex gap-3 items-center">
              <h4 className="text-sm text-label font-bold">
                Delivery Method:{" "}
                <span className="text-black text-sm font-normal">
                  Doorstep Delivery
                </span>
              </h4>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-info-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </svg>
            </div>
            <div className="border border-label mt-3 p-2">
              {details.map((detail, index) => (
                <div
                  key={detail.id}
                  className={`${
                    index === details.length - 1 ? "" : "border-b border-label"
                  } ${index === 0 ? "" : "mt-3"} pb-5`}
                >
                  <h3 className="font-bold text-sm">Shipment Details</h3>

                  <div className="flex gap-3 items-center mt-5">
                    <h4 className="font-bold text-sm text-label">Seller</h4>
                    <div className="flex items-center gap-3 border border-label rounded-3xl h-8">
                      <img
                        src={seller}
                        alt="thrifit seller"
                        className="h-7 w-7"
                      />
                      <p className="pt-2 pr-3 pb-2 pl-2 font-bold text-addressMobile xl:text-xs">
                        {`${detail.product.seller.full_name} Thrifit shop,`}{" "}
                        <span className="text-logoRed">Seller in Lagos</span>
                      </p>
                    </div>
                  </div>
                  <p className="font-bold text-sm text-label mt-3">{`Shipment ${
                    index + 1
                  } of ${details.length}`}</p>
                  <p className="font-normal text-base text-label mt-3">
                    {detail.product.product_name}
                  </p>
                  <p className="font-normal text-addressMobile xl:text-sm text-label mt-3">
                    Delivered between{" "}
                    <span className="text-bsse text-black font-bold">
                      Thursday 17<sup>th</sup> June
                    </span>{" "}
                    and{" "}
                    <span className="text-bsse text-black font-bold">
                      Friday 25<sup>th</sup> June
                    </span>
                  </p>
                  <div className="flex gap-3 items-center mt-3 font-bold text-logoRed">
                    <h4 className="">Delivery Fee: </h4>
                    <div className="flex items-center">
                      <img src={naira} alt="naira" className="inline-block" />
                      <p className="inline-block">45.00</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CartContentArea>

          <CartContentArea>
            <div className="border border-label pl-2 pr-2 pt-5 pb-5">
              <h4 className="text-sm font-bold">Delivery Option</h4>
              <div className="mt-8 flex flex-col md:flex-row gap-10">
                <div className="w-60">
                  <div className="flex gap-3 items-center">
                    <AddressInput
                      name="deliveryCompany"
                      value="Kwik"
                      onchange={handleDeliveryOption}
                    />
                    <p className="font-bold">Kwik</p>
                  </div>
                  <p className="font-normal text-sm mt-4">
                    Delivered between 12/02/2022 and 13/02/2022
                  </p>
                  <p className="font-semibold text-sm mt-3">Price: N780</p>
                </div>
                <div className="w-60">
                  <div className="flex gap-3 items-center">
                    <AddressInput
                      name="deliveryCompany"
                      value="Dhl"
                      onchange={handleDeliveryOption}
                    />
                    <p className="font-bold">DHL</p>
                  </div>
                  <p className="font-normal text-sm mt-4">
                    Delivered between 12/02/2022 and 13/02/2022
                  </p>
                  <p className="font-semibold text-sm mt-3">Price: N780</p>
                </div>
              </div>
            </div>
          </CartContentArea>

          <div className="flex justify-center gap-1 xl:gap-10 items-center mt-8">
            <div className="flex gap-2 xl:gap-5 justify-center items-center w-95.7%">
              <div className="flex w-1/3 xl:w-auto gap-3 justify-center xl:justify-start items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chat-fill w-3 xl:w-6 h-3 xl:h-5 text-label"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9.06 9.06 0 0 0 8 15z" />
                </svg>
                <p className="text-addressMobile xl:text-base">Need Help?</p>
              </div>

              <div className="flex gap-3 w-1/3 xl:w-auto justify-center xl:justify-start items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-truck w-3 xl:w-6 h-3 xl:h-5 text-label"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                </svg>
                <p className="text-addressMobile xl:text-base">
                  Secure Delivery
                </p>
              </div>

              <div className="flex w-33%  xl:w-auto justify-center xl:justify-start gap-3 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-credit-card-2-back-fill w-3 xl:w-6 h-3 xl:h-5 text-label"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5H0V4zm11.5 1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2zM0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1H0z" />
                </svg>
                <p className="text-addressMobile xl:text-base">
                  Secure Payment
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DeliveryDetail;
